<template>
  <!-- Form -->
  <b-col cols="12" md="6">
    <b-container class="contact-section">
      <b-row>
        <b-col class="text-center contact-form-title">
          <h5 class="contact-title">Issue not resolved?</h5>
          <h5 class="contact-title">Contact our support</h5>
          <ul data-v-40ab164b class="footer-text mt-3">
            <li data-v-40ab164b>
              <svg
                data-v-40ab164b
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="envelope"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                class="svg-inline--fa fa-envelope fa-w-16"
              >
                <path
                  data-v-40ab164b
                  fill="currentColor"
                  d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
                  class
                />
              </svg>
              <a href="mailto:reflects@eim.ae">reflects@eim.ae</a>
            </li>
            <li data-v-40ab164b>
              <svg
                data-v-40ab164b
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="phone"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                class="svg-inline--fa fa-phone fa-w-16"
              >
                <path
                  data-v-40ab164b
                  fill="currentColor"
                  d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
                  class
                />
              </svg> +97143470542
            </li>
          </ul>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="contact-section pl-0 pr-0">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7225.419183533515!2d55.2284644!3d25.1116901!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f69575631165b%3A0x93b8457b1cabd013!2s66%2022nd%20St%20-%20Al%20QuozAl%20Quoz%20Industrial%20Area%204%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2seg!4v1600323331599!5m2!1sen!2seg"
        width="100%"
        height="300"
        frameborder="0"
        style="border:0;"
        allowfullscreen
        aria-hidden="false"
        tabindex="0"
      ></iframe>
      <p class="m-2 text-center">
         Warehouse 66, Street 22,<br>
        Al Quoz Industrial Area 4<br>
        Dubai
      </p>
    </b-container>
  </b-col>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      email: "",
      problem: "",
    };
  },
  methods: {
    submitSupportEmail(e) {
      e.preventDefault();
    },
  },
};
</script>

<style scoped>
.contact-btn {
  border: none;
  background-color: #01b4db;
  color: #ffffff;
  border-radius: 7.5px;
}

.contact-form-title {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

h5 {
  margin: 0;
}
a {
  color: black;
}
</style>